import { Controller } from "@hotwired/stimulus"

/*
  Reloads a Turbo Frame when a <select> changes, passing the selected value as
  a query param. Use it when the select lives inside another form (so it can't
  submit its own GET form into the frame) and only the chosen option should be
  rendered server-side.

  Example:
  <div data-controller="frame-reload-on-select"
       data-frame-reload-on-select-url-value="<%= some_path %>"
       data-frame-reload-on-select-param-value="network_id">
    <select data-action="change->frame-reload-on-select#reload">...</select>
    <%= turbo_frame_tag "preview", data: { frame_reload_on_select_target: "frame" } do %>...<% end %>
  </div>
*/
export default class extends Controller {
  static targets = ["frame"]
  static values = { url: String, param: String }

  reload(event) {
    if (!this.hasFrameTarget || !this.urlValue || !this.paramValue) return

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set(this.paramValue, event.target.value)
    this.frameTarget.src = url.toString()
  }

  // A failed reload (e.g. the record became ineligible) must not let Turbo
  // replace the whole page; keep the page and show a short message instead.
  missing(event) {
    event.preventDefault()
    this.frameTarget.textContent = "Preview unavailable. Close and reopen to try again."
  }
}
